import imageCompression from "browser-image-compression";

class Service {

    constructor(model_root) {
        this.model_root = model_root;
    }

    loadFiles(content, type) {
        return fetch(this.model_root + 'shared/files/load_files.php?c=' + content + '&t=' + type, {
            method: "GET"
        })
            .then(response => response.json());
    }

    removeFile(fid) {
        return fetch(this.model_root + 'admin/files/delete_file.php?fid=' + fid, {
            method: "GET"
        })
    }

    // method to upload a _single_ file to a given upload path
    async uploadFile(content_id, file_name, file, file_type) {

        const data = new FormData();
        data.append('content_id', content_id);
        data.append('file_type', file_type);
        data.append('file_name', file_name);
        data.append('file', file);

        return await fetch(this.model_root + 'admin/files/upload_file.php', {
            method: 'POST',
            body: data
        }).then(response => {
            return response.json();
        }).catch(reason => {
            return reason;
        })
    }

    async compressImage(blob) {
        const fileCompressionOptions = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 600,
            useWebWorker: true
        }
        return await imageCompression(blob, fileCompressionOptions);
    }

    async getFilePath(file_id)  {
        console.log(file_id)
        let response = await fetch(this.model_root + 'shared/files/load_file.php?id=' + file_id, {
            method: "GET"
        })
        let responseAsJson = await response.json();
        return responseAsJson.fpath;
    }

}

export default Service;
